
module Elma.ViewModels {
    export class LoginViewModel extends Tapas.ViewModels.LoginViewModel {
        public userType: KnockoutObservable<number> = ko.observable(1); // get usertype
        public visibleFields: KnockoutObservableArray<any> = ko.observableArray([]);

        public dwForgotEmail = ko.observable("robot@1stweb.dk");
        public dwForgotPasswordMailTemplate = ko.observable("Usermanagement/Login/mail.html");
        public dwForgotPasswordMailSubject = ko.observable("Her er dit password");
        private mylogger = Ftw.Base.Config.Logger;



        constructor() {
            super();

            this.userType.subscribe((newValue) => {
                this.visibleFields([]); // empty array
                if (newValue == 1) {
                    this.visibleFields([]);
                }
                else if (newValue == 2) {
                    this.visibleFields([
                        {
                            name: "company",
                            required: true
                        },
                        {
                            name: "cvr",
                            required: true
                        },
                        {
                            name: "ean",
                            required: false
                        }
                    ]);
                }
                else if (newValue == 3) {
                    this.visibleFields([
                        {
                            name: "company",
                            required: true
                        },
                        {
                            name: "ean",
                            required: true
                        }
                    ]);
                }
            });

        };


        //Login function, checksfor fails and gives the user a message
        public Login() {
            var login = new Ftw.Dto.LoginRequest(this.UserName(), this.Password(), this.rememberMe());
            this.UserDataService.Login(login).then((user) => {

                if (user.IsLoggedIn()) {
                    this.mylogger.debug('login successfull');
                    //this.User(user);
                    setTimeout(() =>
                        window.location.reload(),
                        1000);
                } else {
                    this.mylogger.debug('login failed');
                    this.LoginFailed(true);
                    setTimeout(() =>
                        this.LoginFailed(false),
                        10000);
                } setTimeout(() =>
                    this.Loader(true),
                    2000);
            }).catch((error) => {
                if (error.status == 401) {
                    this.LoginWrongDomain(true);
                }
                this.mylogger.debug(error);
            });
        }

        //Recover password function
        public recover() {
            this.ForgottenLoader(true);
            var data = {
                AccessUserEmail: this.email(),
                ForgotPasswordMailTemplate: this.dwForgotPasswordMailTemplate(),
                ForgotPasswordSenderEmail: this.dwForgotEmail(),
                ForgotPasswordMailSubject: this.dwForgotPasswordMailSubject()
            };

            this.data.postForm('/Default.aspx?ID=' + this.loginId + '&LoginAction=Recovery', data)
                .then((data) => {
                    this.confirmation(data);
                    this.ForgottenLoader(false);
                })
                .fail((error) => {
                    this.mylogger.debug(error);
                });
        }

    }
}
